const members = require("./members");

const ALL_WORKSPACE_ROLES = ["owner", "editor", "viewer", "labeler", "reviewer"];

module.exports = { members, ALL_WORKSPACE_ROLES };
